<template>
  <v-card elevation="0" class="bg-white" variant="outlined" style="border: 1px solid #cfd7df !important;">
    <v-card-title class="text-subtitle-2 bgLight2Theme">Información Adicional</v-card-title>

    <v-divider></v-divider>
    <v-card-text>
      <!-- Destino -->
      <div v-if="ticket.destino" class="mb-3">
        <div class="text-caption text-medium-emphasis font-weight-bold mb-1">
          <v-icon size="small" class="mr-1">fa:fa-solid fa-bullseye</v-icon>
          Destino
        </div>
        <div class="text-subtitle-2 font-weight-bold text-grey-darken-3">{{ ticket.destino.nombre }}</div>

      </div>

      <!-- Formato -->
      <div v-if="ticket.formato" class="mb-3">
        <div class="text-caption text-medium-emphasis font-weight-bold mb-1">
          <v-icon size="small" class="mr-1">fa:fa-solid fa-file-image</v-icon>
          Formato
        </div>
        <div class="text-subtitle-2 font-weight-bold text-grey-darken-3">{{ ticket.formato.nombre }}</div>

      </div>

      <!-- Link de Referencia -->
      <div v-if="ticket.link_referencia" class="mb-2">
        <div class="text-caption text-medium-emphasis font-weight-bold mb-1">
          <v-icon size="small" class="mr-1">fa:fa-solid fa-link</v-icon>
          Link de Referencia
        </div>
        <a :href="ticket.link_referencia" target="_blank" rel="noopener noreferrer" 
          class="text-subtitle-2 text-primary text-decoration-none d-flex align-center">
          <span class="text-truncate" style="max-width: 100%;">{{ ticket.link_referencia }}</span>
          <v-icon size="x-small" class="ml-1">mdi:mdi-open-in-new</v-icon>
        </a>
      </div>

      <!-- Mensaje si no hay información -->
      <div v-if="!ticket.destino && !ticket.formato && !ticket.link_referencia" class="text-center py-3">
        <v-icon size="small" color="grey-lighten-1" class="mb-2">mdi:mdi-information-outline</v-icon>
        <div class="text-caption text-medium-emphasis">
          No hay información adicional disponible
        </div>
      </div>
    </v-card-text>

  </v-card>
</template>


<script>
import Filters from '@/modules/Shared/Filters';


export default {
  mixins: [Filters],
  props: {
    ticket: {
      type: Object,
      require: true
    }
  }
}
</script>

<style scoped>
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
